import { Field, FieldGroup, FieldLabel, Form } from '../Components/Form';
import * as React from 'react';
import { StepProps } from '../../types';
import { useTranslation } from 'react-i18next';

export default function CustomerInfo({ form, setForm, onStepCompleted }: StepProps) {
    const { t } = useTranslation();

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        onStepCompleted();
    };

    const [phoneType, setPhoneType] = React.useState<'mobil' | 'privat'>('mobil');

    return (
        <Form className="mx-auto max-w-md" onSubmit={handleSubmit}>
            <FieldGroup>
                <Field>
                    <FieldLabel htmlFor="anrede">{t('field.salutation.label')}</FieldLabel>
                    <select
                        name="anrede"
                        value={form.customer.anrede ?? undefined}
                        onChange={(e) =>
                            setForm((f: any) => ({
                                ...f,
                                customer: {
                                    ...(f?.customer ?? {}),
                                    anrede: e.target.value,
                                },
                            }))
                        }
                        required
                        id="anrede"
                    >
                        <option value="">{t('action.select')}</option>
                        <option value="F">{t('field.salutation.mrs')}</option>
                        <option value="M">{t('field.salutation.mr')}</option>
                        <option value="FIR">{t('field.salutation.company')}</option>
                    </select>
                </Field>

                <Field>
                    <FieldLabel htmlFor="leading_title">{t('field.title.label')}</FieldLabel>
                    <input
                        name="leading_title"
                        value={form.customer.leading_title}
                        onChange={(e) =>
                            setForm((f: any) => ({
                                ...f,
                                customer: {
                                    ...(f?.customer ?? {}),
                                    leading_title: e.target.value,
                                },
                            }))
                        }
                        type="text"
                        minLength={2}
                        maxLength={50}
                        id="leading_title"
                    />
                </Field>
                <Field>
                    <FieldLabel htmlFor="first_name">{t('field.firstName.label')}</FieldLabel>
                    <input
                        name="first_name"
                        value={form.customer.first_name}
                        onChange={(e) =>
                            setForm((f: any) => ({
                                ...f,
                                customer: {
                                    ...(f?.customer ?? {}),
                                    first_name: e.target.value,
                                },
                            }))
                        }
                        type="text"
                        required
                        minLength={2}
                        maxLength={255}
                        id="first_name"
                    />
                </Field>
                <Field>
                    <FieldLabel htmlFor="last_name">{t('field.lastName.label')}</FieldLabel>
                    <input
                        name="last_name"
                        value={form.customer.last_name}
                        onChange={(e) =>
                            setForm((f: any) => ({
                                ...f,
                                customer: {
                                    ...(f?.customer ?? {}),
                                    last_name: e.target.value,
                                },
                            }))
                        }
                        type="text"
                        required
                        minLength={2}
                        maxLength={255}
                        id="last_name"
                    />
                </Field>
                <Field>
                    <FieldLabel htmlFor="email">{t('field.email.label')}</FieldLabel>
                    <input
                        name="email"
                        value={form.customer.email}
                        onChange={(e) =>
                            setForm((f: any) => ({
                                ...f,
                                customer: {
                                    ...(f?.customer ?? {}),
                                    email: e.target.value,
                                },
                            }))
                        }
                        type="email"
                        required
                        minLength={2}
                        maxLength={255}
                        id="email"
                    />
                </Field>
                <Field>
                    <FieldLabel htmlFor="telefon">{t('field.phone.label')}</FieldLabel>

                    <div className="flex w-full">
                        <input
                            className={'block min-w-0 grow'}
                            name="telefon"
                            value={phoneType === 'mobil' ? form.customer.telefon_mobil : form.customer.telefon_privat}
                            onChange={(e) =>
                                setForm((f: any) => ({
                                    ...f,
                                    customer: {
                                        ...(f?.customer ?? {}),
                                        telefon_mobil: phoneType === 'mobil' ? e.target.value : '',
                                        telefon_privat: phoneType === 'privat' ? e.target.value : '',
                                    },
                                }))
                            }
                            type="text"
                            minLength={2}
                            maxLength={50}
                            id="telefon"
                        />

                        <div className={'grid shrink-0 grid-cols-1'}>
                            <select
                                onChange={(e) => {
                                    if (phoneType === 'mobil') {
                                        setForm((f: any) => ({
                                            ...f,
                                            customer: {
                                                ...(f?.customer ?? {}),
                                                telefon_mobil: '',
                                                telefon_privat: form.customer.telefon_mobil ?? '',
                                            },
                                        }));
                                    } else {
                                        setForm((f: any) => ({
                                            ...f,
                                            customer: {
                                                ...(f?.customer ?? {}),
                                                telefon_mobil: form.customer.telefon_privat ?? '',
                                                telefon_privat: '',
                                            },
                                        }));
                                    }
                                    setPhoneType(e.target.value as 'mobil' | 'privat');

                                }}
                                className={'col-start-1 row-start-1 w-full pr-14'}
                            >
                                <option value='mobil'>{t('field.phone.mobile')}</option>
                                <option value='privat'>{t('field.phone.private')}</option>
                            </select>
                        </div>
                    </div>
                </Field>

                <Field>
                    <FieldLabel htmlFor="street">{t('field.street.label')}</FieldLabel>
                    <input
                        name="street"
                        value={form.customer.street}
                        onChange={(e) =>
                            setForm((f: any) => ({
                                ...f,
                                customer: {
                                    ...(f?.customer ?? {}),
                                    street: e.target.value,
                                },
                            }))
                        }
                        type="text"
                        minLength={2}
                        maxLength={50}
                        id="street"
                    />
                </Field>

                <Field>
                    <FieldLabel htmlFor="post_code">{t('field.postCode.label')}</FieldLabel>
                    <input
                        name="post_code"
                        value={form.customer.post_code}
                        onChange={(e) =>
                            setForm((f: any) => ({
                                ...f,
                                customer: {
                                    ...(f?.customer ?? {}),
                                    post_code: e.target.value,
                                },
                            }))
                        }
                        type="text"
                        minLength={2}
                        maxLength={50}
                        required
                        id="post_code"
                    />
                </Field>

                <Field>
                    <FieldLabel htmlFor="city">{t('field.city.label')}</FieldLabel>
                    <input
                        name="city"
                        value={form.customer.city}
                        onChange={(e) =>
                            setForm((f: any) => ({
                                ...f,
                                customer: {
                                    ...(f?.customer ?? {}),
                                    city: e.target.value,
                                },
                            }))
                        }
                        type="text"
                        minLength={2}
                        maxLength={50}
                        required
                        id="city"
                    />
                </Field>
            </FieldGroup>

            <div className={'mt-7 flex'}>
                <button type="submit" className="disabled:opacity-50">
                    {t('action.continue')}
                </button>
            </div>
        </Form>
    );
}
